module.exports = __webpack_public_path__ + "img/listConent.87052e7.webp";